/**
 * Checks if the current route is "clean" (has no query parameters).
 * A clean route means the user navigated to the base path without any filters, pagination, or sorting params.
 * This allows the system to hydrate from stored state. If URL has any params, they take precedence.
 *
 * @returns true if the URL has no query parameters, false otherwise
 */
export function isCleanRoute(): boolean {
  // Simple check: if URL has no query params, it's clean
  // This ensures URL is always the source of truth when params exist
  const search = window.location.search;

  return !search || search.trim() === '' || search.trim() === '?';
}
